import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import'rxjs/add/observable/throw';
import'rxjs/add/observable/interval';
import'rxjs/add/observable/timer';
import { AuthConfiguration } from '../modules/auth.configuration';
import { OidcSecurityCommon } from './oidc.security.common';
import { AuthWellKnownEndpoints } from './auth.well-known-endpoints';
import { Observer } from 'rxjs/Observer';
export class OidcSecurityCheckSession {
private sessionIframe: any;
private iframeMessageEvent: any;

     onCheckSessionChanged: EventEmitter<any> = new EventEmitter<any>(true);
/**
 * @param {?} authConfiguration
 * @param {?} oidcSecurityCommon
 * @param {?} authWellKnownEndpoints
 */
constructor(
private authConfiguration: AuthConfiguration,
private oidcSecurityCommon: OidcSecurityCommon,
private authWellKnownEndpoints: AuthWellKnownEndpoints
    ) {
    }
/**
 * @return {?}
 */
init() {
        this.sessionIframe = window.document.createElement('iframe');
        this.oidcSecurityCommon.logDebug(this.sessionIframe);
        this.sessionIframe.style.display = 'none';
        this.sessionIframe.src = this.authWellKnownEndpoints.check_session_iframe;

        window.document.body.appendChild(this.sessionIframe);
        this.iframeMessageEvent = this.messageHandler.bind(this);
        window.addEventListener('message', this.iframeMessageEvent, false);

        return Observable.create((observer: Observer<any>) => {
            this.sessionIframe.onload = () => {
                observer.next(this);
                observer.complete();
            }
        });
    }
/**
 * @param {?} session_state
 * @param {?} clientId
 * @return {?}
 */
pollServerSession(session_state: any, clientId: any) {
        let /** @type {?} */ source = Observable.timer(3000, 3000)
            .timeInterval()
            .pluck('interval')
            .take(10000);

        let /** @type {?} */ subscription = source.subscribe(() => {
                this.oidcSecurityCommon.logDebug(this.sessionIframe);
                this.sessionIframe.contentWindow.postMessage(clientId + ' ' + session_state, this.authConfiguration.stsServer);
            },
            (err: any) => {
                this.oidcSecurityCommon.logError('pollServerSession error: ' + err);
            },
            () => {
                this.oidcSecurityCommon.logDebug('checksession pollServerSession completed');
            });
    }
/**
 * @param {?} e
 * @return {?}
 */
private messageHandler(e: any) {
        if (e.origin === this.authConfiguration.stsServer &&
            e.source === this.sessionIframe.contentWindow
        ) {
            if (e.data === 'error') {
                this.oidcSecurityCommon.logWarning('error from checksession messageHandler');
            } else if (e.data === 'changed') {
                this.onCheckSessionChanged.emit();
            } else {
                this.oidcSecurityCommon.logDebug(e.data + ' from checksession messageHandler');
            }
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AuthConfiguration, },
{type: OidcSecurityCommon, },
{type: AuthWellKnownEndpoints, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onCheckSessionChanged': [{ type: Output },],
};
}

function OidcSecurityCheckSession_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecurityCheckSession.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecurityCheckSession.ctorParameters;
/** @type {?} */
OidcSecurityCheckSession.propDecorators;
/** @type {?} */
OidcSecurityCheckSession.prototype.sessionIframe;
/** @type {?} */
OidcSecurityCheckSession.prototype.iframeMessageEvent;
/** @type {?} */
OidcSecurityCheckSession.prototype.onCheckSessionChanged;
/** @type {?} */
OidcSecurityCheckSession.prototype.authConfiguration;
/** @type {?} */
OidcSecurityCheckSession.prototype.oidcSecurityCommon;
/** @type {?} */
OidcSecurityCheckSession.prototype.authWellKnownEndpoints;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
